<template>
  <v-form ref="roleForm">
    <v-text-field
      v-model="data.Nombre"
      :rules="rules.name"
      label="Nombre"
      outlined
      dense
      required
    ></v-text-field>

    <v-text-field
      v-model="data.Codigo"
      :rules="rules.codigo"
      label="Código || Alias"
      outlined
      dense
      required
    ></v-text-field>

    <v-row>
      <v-col cols="2">
        <v-switch v-model="data.Activo" label="Activo"></v-switch>
      </v-col>
    </v-row>

    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
export default {
  name: "DepartamentosForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      data: {
        Activo: true,
        Nombre: null,
        Codigo: null,
      },
      rules: {
        name: [(value) => !!value || "El nombre es obligatorio"],
        codigo: [(value) => !!value || "El código es obligatorio"],
      },
    };
  },
  methods: {
    checkForm() {
      if (this.$refs.roleForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.data;

      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.Id;
      }

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    if (this.edit) {
      this.data.Activo = this.dataEdit.Activo;
      this.data.Nombre = this.dataEdit.Nombre;
      this.data.Codigo = this.dataEdit.Codigo;
    }
  },
};
</script>
